import type {
  CreateContextDocumentRequest,
  ListContextDocumentsResponse,
  ProjectContextDocument,
  UpdateContextDocumentRequest,
} from '@protoss/shared';
import { apiFetch } from '../../../lib/apiClient';

const BASE = '/api/project';

export const contextDocsApi = {
  list(projectUuid: string, sourceSystem?: string | null): Promise<ListContextDocumentsResponse> {
    const qs = sourceSystem ? `?sourceSystem=${encodeURIComponent(sourceSystem)}` : '';
    return apiFetch(`${BASE}/${projectUuid}/context-docs${qs}`);
  },

  get(projectUuid: string, docUuid: string): Promise<{ document: ProjectContextDocument }> {
    return apiFetch(`${BASE}/${projectUuid}/context-docs/${docUuid}`);
  },

  create(
    projectUuid: string,
    data: CreateContextDocumentRequest
  ): Promise<{ document: ProjectContextDocument }> {
    return apiFetch(`${BASE}/${projectUuid}/context-docs`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  update(
    projectUuid: string,
    docUuid: string,
    data: UpdateContextDocumentRequest
  ): Promise<{ document: ProjectContextDocument }> {
    return apiFetch(`${BASE}/${projectUuid}/context-docs/${docUuid}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  delete(projectUuid: string, docUuid: string): Promise<void> {
    return apiFetch(`${BASE}/${projectUuid}/context-docs/${docUuid}`, { method: 'DELETE' });
  },
};
